import { makeDoFetchJiraIssueSearch } from 'ducks/integrations/jiraShared'

export default makeDoFetchJiraIssueSearch(
  'integrations/jira_cloud',
  cloudId => `proxy/atlassian/ex/jira/${cloudId}/rest/api/3/search`
)
